module.exports = __webpack_public_path__ + "img/open_app_icon1.7d7799b0.png";